// extracted by mini-css-extract-plugin
module.exports = {"arrow":"FoldShowMore_arrow__PxxlZ","link":"FoldShowMore_link__6F2oR","fsmFadeMoveDown":"FoldShowMore_fsmFadeMoveDown__pEJjJ"};